import React from 'react';
import { Link } from 'react-router-dom';

// Recent Post Thumb Images
import thumb1 from '../../assets/img/blog/inner/1.jpg'
import thumb2 from '../../assets/img/blog/inner/2.jpg'
import thumb3 from '../../assets/img/blog/inner/3.jpg'
import thumb4 from '../../assets/img/blog/inner/4.jpg'

const RecentPostWidget = () => {
    return (
        <div className="recent-posts mb-50">
            <div className="widget-title">
                <h3 className="title">Latest Posts</h3>
            </div>
            <div className="recent-post-widget">
                <div className="post-img">
                    <Link to="/insight/insight-details">
                        <img
                            src={thumb1}
                            alt="something"
                        />
                    </Link>
                </div>
                <div className="post-desc">
                    <Link to="/insight/insight-details">Pen Source Job Report Show More Openings Fewer </Link>
                    <span className="date">
                        <i className="fa fa-calendar"></i>
                        January 21, 2020
                    </span>
                </div>
            </div>
            <div className="recent-post-widget">
                <div className="post-img">
                    <Link to="/insight/insight-details">
                        <img
                            src={thumb2}
                            alt="something"
                        />
                    </Link>
                </div>
                <div className="post-desc">
                    <Link to="/insight/insight-details">Tech Products That Makes Its Easier to Stay at Home</Link>
                    <span className="date">
                        <i className="fa fa-calendar"></i>
                        January 21, 2020
                    </span>
                </div>
            </div>
            <div className="recent-post-widget">
                <div className="post-img">
                    <Link to="/insight/insight-details">
                        <img
                            src={thumb3}
                            alt="something"
                        />
                    </Link>
                </div>
                <div className="post-desc">
                    <Link to="/insight/insight-details">Necessity May Give Us Your Best Virtual Court System </Link>
                    <span className="date">
                        <i className="fa fa-calendar"></i>
                        January 21, 2020
                    </span>
                </div>
            </div>
            <div className="recent-post-widget">
                <div className="post-img">
                    <Link to="/insight/insight-details">
                        <img
                            src={thumb4}
                            alt="something"
                        />
                    </Link>
                </div>
                <div className="post-desc">
                    <Link to="/insight/insight-details">Servo Project Joins The Linux Foundation Fold Desco </Link>
                    <span className="date">
                        <i className="fa fa-calendar"></i>
                        January 21, 2020
                    </span>
                </div>
            </div>
        </div>
    )
}

export default RecentPostWidget;